import { Box, Modal, Radio, RadioGroup, FormControlLabel } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AddOrEditSkillsModal from './AddOrEditSkillsModal'
import '../styles.scss'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import RadioButtonChecked from '../assets/imgs/radio-button-round-checked.svg'
import RadioButtonUnchecked from '../assets/imgs/radio-button-round-unchecked.svg'
import StarIconGolden from '../assets/imgs/star-icon-golden.svg'
import { getAllData, getDataById } from '../apis/generalApis'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ServiceFilterModal = ({
  serviceFilterModal,
  handleServirFilterModal,
  selectedService,
  setSelectedService,
}) => {
  useEffect(() => {
    getAllServices({})
  }, [])
  const [servicesList, setServicesList] = useState([])
  const getAllServices = async (body) => {
    let result = await getDataById('show-services')
    if (result?.success === true && result.data) {
      setServicesList(result.data)
    }
  }

  return (
    <div>
      <Modal
        open={serviceFilterModal}
        onClose={() => handleServirFilterModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="set-skill-rate-modal">
          <div className="text-center">
            <h5 className="color-primary">Select Service</h5>
            <hr />
            <div>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="five-star"
                name="radio-buttons-group"
              >
                {servicesList &&
                  servicesList?.map((item, index) => (
                    <FormControlLabel
                      value={item.name}
                      key={item.id}
                      control={
                        <Radio
                          icon={
                            // <img
                            //   src={RadioButtonUnchecked}
                            //   height={20}
                            //   alt=""
                            //   className="p-0"
                            // />
                            <div className="unchecked-radio-div"></div>
                          }
                          checkedIcon={
                            <img
                              src={RadioButtonChecked}
                              height={20}
                              alt=""
                              className="p-0"
                            />
                            // <div className="unchecked-radio-div">
                            //   <div className="checked-radio-div"></div>
                            // </div>
                          }
                        />
                      }
                      className="align-items-center flex-wrap m-0 service-filter-option"
                      style={
                        selectedService?.id === item.id
                          ? {
                              background:
                                'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 51%, #2992FB 100%) 0% 0% no-repeat padding-box',
                              borderRadius: '16px',
                            }
                          : {}
                      }
                      label={
                        <p
                          className={`fs-18 fw-bold service-option-title ${
                            selectedService?.id === item.id
                              ? 'text-black'
                              : 'color-primary'
                          }`}
                        >
                          {item.name}
                        </p>
                      }
                      checked={selectedService?.id === item.id}
                      onClick={(e) => {
                        setSelectedService(item)
                      }}
                    />
                  ))}
              </RadioGroup>
            </div>
          </div>
          {/* <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100">
            <div
              onClick={toggleSortDropdown}
              className="sort-dropdown d-flex flex-wrap justify-content-around align-items-center w-100 px-1"
            >
              <p className="fs-18 m-0">Sort By</p>
              <p className="fs-12 m-0 color-primary fw-bold d-flex align-items-center">
                {'A -> Z'}
                <span>
                  <KeyboardArrowDownIcon />
                </span>
              </p>
            </div>
            {sortDropdown.opened && (
              <div className="dropdown-content">
                {sortByDropdownOptions.map((item, index) => (
                  <div
                    key={index}
                    className={`dropdown-option hover-div ${
                      sortDropdown.activeOption === index
                        ? 'active-dropdown-option'
                        : ''
                    }`}
                    onClick={() => {
                      setSortDropdown((prev) => ({
                        ...prev,
                        opened: false,
                        activeOption: index,
                      }))
                      setSortDropdownOption(item?.value)
                    }}
                  >
                    <p className="fs-12">{item?.label}</p>
                  </div>
                ))}
              </div>
            )}
          </div> */}
        </Box>
      </Modal>
    </div>
  )
}

export default ServiceFilterModal
